/**
 * @generated SignedSource<<9f7306323a7db194426e42a8888b816d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentCompanySupportPhone_company$data = {
  readonly preferences: {
    readonly support: {
      readonly phone: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "PaymentCompanySupportPhone_company";
};
export type PaymentCompanySupportPhone_company$key = {
  readonly " $data"?: PaymentCompanySupportPhone_company$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentCompanySupportPhone_company">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentCompanySupportPhone_company",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CompanyPreferences",
      "kind": "LinkedField",
      "name": "preferences",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CompanyPreferencesSupport",
          "kind": "LinkedField",
          "name": "support",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "phone",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Company",
  "abstractKey": null
};

(node as any).hash = "9803802c1d541c6b75569679963f9f0b";

export default node;
